<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-bodymatter element-type-chapter element-with-heading" id="memorial">
<div class="heading heading-with-title heading-without-image" id="memorial-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Memorial</h1>
</div>
</div>
</div>
</div>
<div class="text" id="memorial-text">
<p class="first first-in-chapter first-full-width"><span class="first-phrase">The roar</span> of the ocean echoed through the empty sky, but no one was left alive to hear it. Waves, glinting from filtered light, lapped up against a long beach, leaving a deposit of deadly radiation which had made even the life-spawning sea sterile.</p>
<p class="subsq">The sun burned down through a radioactive haze, warming nothing but the dead sands. No bird flew in the sky, no fish swam in the sea, no man walked the earth. Apart from the roar of the poisonous sea and the gentle sound of the just-as-deadly wind, the world was silent—the earth was dead.</p>
<p class="subsq">The waves washed the shore again, taking with them a few grains of sand, exposing something to the sun’s glare. More sand washed away, and the days passed.</p>
<p class="subsq">The object became uncovered, something made of glass, clear, uncolored, but clouded slightly. Its shape was not what it had been, but was now warped slightly from exposure to the furious, raging heat of countless atomic blasts.</p>
<p class="subsq">It had been a bottle once; and now it comprised the entire remnants of mankind. The bottle was the only representative of the human race, a memorial, a monument to the way of life which had been so suddenly destroyed.</p>
<p class="subsq">Visitors coming and finding the earth dead would find this bottle, and from it try to reconstruct the civilization which had spawned it.</p>
<p class="subsq">Paint on the bottle formed letters, now meaningless. The paint was blistered and burned, but the message, for all who could read it, was plain.</p>
<p class="subsq">The words read: COKE ADDS LIFE.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// memorial.vue?6e9efb02